
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bathroom': {
    width: 16,
    height: 16,
    viewBox: '0 0 21.009 20.001',
    data: '<path pid="0" d="M4.012 18v1a.94.94 0 0 0 1.035 1q.965 0 .965-1v-1h9v.982a.892.892 0 0 0 1 1.018.892.892 0 0 0 1-1.018V18a11.777 11.777 0 0 0 2-2 6.486 6.486 0 0 0 1-4.119c0-1.447 1-.785 1-1.881 0-.793 0-1-1-1h-17V3c0-.541 1.153-.775 1.153-.388a3.13 3.13 0 0 0 .663 3c.912.851 2.081 0 2.992-.806.624-.553 1.372-1.63 1-2.352a2.91 2.91 0 0 0-2.353-1.176 1.71 1.71 0 0 0-.962.374A2.159 2.159 0 0 0 3.426 0C2.012.031 1.012 1.585 1.012 3v6Q-.075 8.858.006 10c.081 1.142.979.5 1.006 2s0 2.8 1 4a13.954 13.954 0 0 0 2 2z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
